import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const url = error.config?.url || "";
    const hadToken = !!localStorage.getItem("token");
    if (error.response?.status === 401 && hadToken && !url.includes("/auth/login") && !url.includes("/auth/logout") && !url.includes("/auth/refresh")) {
      window.dispatchEvent(new Event("auth-expired"));
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getToken() {
  return localStorage.getItem("token");
}

export async function openDownload(path) {
  const w = window.open("", "_blank");
  try {
    const { data } = await api.post("/auth/download-token");
    const url = `${API}${path}${path.includes("?") ? "&" : "?"}auth=${encodeURIComponent(data.token)}`;
    if (w) w.location.href = url; else window.location.href = url;
  } catch {
    if (w) w.close();
  }
}
